module.exports = __webpack_public_path__ + "static/poster-265bc57f37029e634e1c019011096758.png";